import * as React from 'react';

import TableRowBusy from './TableRowBusy';

interface Props {
    children?: React.ReactNode;
    loading?: boolean;
    /**
     * Number of rows we want to display loader
     */
    loadingRows?: number;
    /**
     * Number of columns we want to display loader
     */
    loadingColumns?: number;
    mouseDown?: string;
}

const TableBody = ({ children, loading = false, loadingRows = 0, loadingColumns, mouseDown, ...rest }: Props) => {
    const childrenWithProps = React.Children.map(children, (child) => {
        if (React.isValidElement(child)) {
            return React.cloneElement(child as React.ReactElement<any>, { mouseDown });
        }
        return child;
    });
    const rowsLoading = (
        <>
            {[...Array(loadingRows)].map((v, i) => (
                <TableRowBusy loadingColumns={loadingColumns} key={i.toString()} />
            ))}
        </>
    );
    return <tbody {...rest}>{loading ? rowsLoading : childrenWithProps}</tbody>;
};

export default TableBody;
